const AboutCousal = () => {
  return (
    <div 
      id="carouselExampleSlidesOnly" 
      className="carousel slide about-carousel-wrapper" 
      data-bs-ride="carousel"
    >
      <div className="carousel-inner">
        
        <div className="carousel-item active" data-bs-interval="3000">
          <img 
            src="img/about.jpg" 
            className="d-block w-100 about-carousel-img" 
            alt="about"
          />
        </div>

        <div className="carousel-item" data-bs-interval="3000">
          <img 
            src="img/about2.jpg" 
            className="d-block w-100 about-carousel-img" 
            alt="about2"
          />
        </div>

        <div className="carousel-item" data-bs-interval="3000">
          <img 
            src="img/main3.jpg" 
            className="d-block w-100 about-carousel-img" 
            alt="about3"
          />
        </div>

      </div>
    </div>
  );
};

export default AboutCousal;
